import { BigFormRow, FormInputGroup } from 'framework/ui/layout';
import { TextInput, CommaListInput } from 'framework/form';
import ActivityTypeInput from 'domain/sales/shared/timeline/activity/form/input/ActivityTypeInput';
import { ARTIFACT_ID } from 'domain/shared/artifact';
import CrmNoteWysiwygInput from 'domain/sales/shared/input/CrmNoteWysiwygInput';
import { ActivityType } from 'domain/shared/timeline';
import CompositeDocumentUploaderInput from 'domain/sales/opportunity/shared/storage/components/CompositeDocumentUploaderInput';

const emailListLabelHint = '(enter comma-separated e-mail addresses)';

const ActivityForm = ({ isEditForm = false }: { isEditForm?: boolean }) => (
  <>
    <BigFormRow>
      <ActivityTypeInput source="activityType" isVisible={!isEditForm} />
    </BigFormRow>
    <BigFormRow>
      <TextInput source="subject" />
    </BigFormRow>
    <BigFormRow>
      <CrmNoteWysiwygInput artifactsSource="attachmentsIds" source="description" />
    </BigFormRow>

    <FormInputGroup isVisible={data => ActivityType[data.activityType as never] === ActivityType.EMAIL}>
      <BigFormRow>
        <TextInput source="senderEmail" label="Sender" />
      </BigFormRow>
      <BigFormRow>
        <CommaListInput source="receiversEmails" label="Receivers" labelHint={emailListLabelHint} />
      </BigFormRow>
      <BigFormRow>
        <CommaListInput source="ccEmails" label="CC" labelHint={emailListLabelHint} />
      </BigFormRow>
      <BigFormRow>
        <CommaListInput source="bccEmails" label="BCC" labelHint={emailListLabelHint} />
      </BigFormRow>
    </FormInputGroup>

    <FormInputGroup isVisible={data => ActivityType[data.activityType as never] === ActivityType.CALL}>
      <BigFormRow>
        <TextInput source="communicationChannel" />
      </BigFormRow>
    </FormInputGroup>

    <FormInputGroup isVisible={data => ActivityType[data.activityType as never] === ActivityType.MEETING}>
      <BigFormRow>
        <TextInput source="location" />
      </BigFormRow>
    </FormInputGroup>

    <BigFormRow>
      <CompositeDocumentUploaderInput
        label="Attachments"
        artifactTypeId={ARTIFACT_ID.CRM_ATTACHMENT}
        artifactsListSource={'attachmentsIds'}
        documentsListsSource={'artifactPaths'}
      />
    </BigFormRow>
  </>
);

export default ActivityForm;
